export const SegmentPrice = (json: ISegmentPrice): ISegmentPriceModel => {
	const fromJSON = (json: ISegmentPrice) => {
		const { loyalty_points, amount_gross, name_en, ...rest } = json
		return {
			...rest,
			amountGross: amount_gross,
			loyaltyPoints: loyalty_points || 0,
			nameEN: name_en,
		}
	}

	return { ...fromJSON(json) }
}

export const ProductSegment = (json: IProductSegment): IProductSegmentModel => {
	const fromJSON = (json: IProductSegment) => {
		const { initial_price, price_per_day, loyalty_points, crm_id, min_days, regular_price, promotional_price, name_en, ...rest } = json
		return {
			...rest,
			crmId: crm_id,
			initialPrice: initial_price || initial_price === 0 ? initial_price / 100 : undefined,
			loyaltyPoints: loyalty_points,
			minDays: min_days,
			pricePerDay: price_per_day || price_per_day === 0 ? price_per_day / 100 : undefined,
			regularPrice: regular_price ? SegmentPrice(regular_price) : null,
			promotionalPrice: promotional_price ? SegmentPrice(promotional_price) : null,
			nameEN: name_en,
		}
	}

	return { ...fromJSON(json) }
}

export const productSegmentToJSON = (obj: Partial<IProductSegmentModel>): Partial<IProductSegment> => {
	const { initialPrice, pricePerDay, crmId, ...rest } = obj
	return {
		...rest,
		crm_id: crmId,
		initial_price: initialPrice || initialPrice ? initialPrice * 100 : undefined,
		price_per_day: pricePerDay || pricePerDay ? pricePerDay * 100 : undefined,
	}
}
